module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('br'), _vm._v(" "), _c('font', {
    attrs: {
      "color": "#9ACD32"
    }
  }, [_c('b', [_vm._v("订单号:"), _c('span', {
    staticStyle: {
      "color": "#777",
      "font-size": "15px"
    }
  }, [_vm._v(_vm._s(_vm.increment_id))])])]), _c('br'), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('font', {
    attrs: {
      "color": "#9ACD32"
    }
  }, [_c('b', [_vm._v("订单支付金额："), _c('span', {
    staticStyle: {
      "color": "#f00",
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.total_amount))])])]), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('button', {
    staticStyle: {
      "width": "210px",
      "height": "50px",
      "border-radius": "15px",
      "background-color": "#FE6714",
      "border": "0px #FE6714 solid",
      "cursor": "pointer",
      "color": "white",
      "font-size": "16px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.callpay()
      }
    }
  }, [_vm._v("立即支付")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cc695d9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/payment/wxpay/jsapi/Start.vue
// module id = 266
// module chunks = 1